var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66211 10.9375C2.66211 10.5095 3.00909 10.1625 3.43711 10.1625H7.81211C8.24013 10.1625 8.58711 10.5095 8.58711 10.9375C8.58711 11.3655 8.24013 11.7125 7.81211 11.7125H4.21211V16.5625C4.21211 16.9905 3.86513 17.3375 3.43711 17.3375C3.00909 17.3375 2.66211 16.9905 2.66211 16.5625V10.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41211 16.5625C1.41211 16.1345 1.75909 15.7875 2.18711 15.7875H17.8121C18.2401 15.7875 18.5871 16.1345 18.5871 16.5625C18.5871 16.9905 18.2401 17.3375 17.8121 17.3375H2.18711C1.75909 17.3375 1.41211 16.9905 1.41211 16.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03711 7.18748C7.03711 6.75946 7.38409 6.41248 7.81211 6.41248H12.1871C12.6151 6.41248 12.9621 6.75946 12.9621 7.18748C12.9621 7.6155 12.6151 7.96248 12.1871 7.96248H8.58711V16.5625C8.58711 16.9905 8.24013 17.3375 7.81211 17.3375C7.38409 17.3375 7.03711 16.9905 7.03711 16.5625V7.18748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4121 3.43748C11.4121 3.00945 11.7591 2.66248 12.1871 2.66248H16.5621C16.9901 2.66248 17.3371 3.00945 17.3371 3.43748V16.5625C17.3371 16.9905 16.9901 17.3375 16.5621 17.3375H12.1871C11.7591 17.3375 11.4121 16.9905 11.4121 16.5625V3.43748ZM12.9621 4.21248V15.7875H15.7871V4.21248H12.9621Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsInactive);
export default __webpack_public_path__ + "static/media/analytics-inactive.9c25f19046c13ca0b003c21ae24011af.svg";
export { ForwardRef as ReactComponent };